//-------- 全额抵扣模块 --------开始
//全额抵扣信息分页查询
import request from './request.js';
import {requestbody} from './request.js'
import config from "../../configHttp";

export async function qedk_infoPage_api(params = {

}) {
    return await requestbody('/qedk/query', 'post', params)
}

//页面初始化
export async function qedk_initQedkInfo_api(params = {

}) {
    return await requestbody('/qedk/init', 'post', params)
}
//数据来源配置分页查询
export async function qedk_dataOriginInfoPage_api(params = {

}) {
    return await requestbody('/qedk/dataorigin/find', 'post', params)
}
//更新取数
export async function qedk_updateIinvoutData_api(params = {

}) {
    return await requestbody('/qedk/date/update', 'post', params)
}
//清空数据
export async function qedk_clearNowTax_api(params = {

}) {
    return await requestbody('/qedk/date/clear', 'post', params)
}
//进项转出 修改数据来源
export async function qedk_updateLy_api(params = {

}) {
    return await requestbody('/qedk/dataorigin/update', 'post', params)
}
//明细登记查询
export async function qedk_findDetails_api(params = {

}) {
    return await requestbody('/qedk/details/query', 'post', params)
}
//明细登记保存
export async function qedk_update_api(params = {

}) {
    return await requestbody('/qedk/update', 'post', params)
}
//进项发票查询
export async function qedk_fapiaoFind_api(params = {

}) {
    return await requestbody('/qedk/iinv/fapiaoQuery', 'post', params)
}
